<template>
    <div class="ui-content dashboard">
        <v-card class="mx-auto normal-card autohg">
            <div class="negative-marking-impact">
                <div class="accordian-block">
                    <v-expansion-panels>
                        <v-expansion-panel v-if="!ishide">
                            <v-expansion-panel-header>
                                <div class="expansion-title">Compare Your Score</div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <CompareYourScore :studentId="studentId" />
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel v-if="routeName !== 'response-analysis-practice'">
                            <v-expansion-panel-header>
                                <div class="expansion-title">Negative Marking Impact</div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <NegativeMarkingImpact :studentId="studentId" />
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div class="expansion-title">Chapterwise Performance</div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <ChapterwisePerformance :studentId="studentId" />
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import CompareYourScore from "@/components/student/CompareYourScore.vue";
import NegativeMarkingImpact from "@/components/student/NegativeMarkingImpact.vue";
import ChapterwisePerformance from "@/components/student/ChapterwisePerformance.vue";
export default {
    name: "ResponseA",
    mounted() {
        this.routeName = this.$route.name;
        this.studentId = this.$route.params.student_id;
        if (this.$route && this.$route.params && this.$route.params.hide) {
            this.ishide=this.$route.params.hide;
        }
    },
    components: {
        CompareYourScore,
        NegativeMarkingImpact,
        ChapterwisePerformance
    },
    data() {
        return {
            studentId: null,
            ishide:false,
            routeName: null
        };
    }
};
</script>